import _ from 'lodash';
import { List, Map, fromJS } from 'immutable';
import { createStore } from 'fluxible/addons';
import CustomerConstants from '../constants/CustomerConstants';
import ShoppingCartConstants from '../constants/ShoppingCartConstants';
import ShoppingCart from '../models/ShoppingCart';
import { RequestStates } from './PaginatedStore';

let ShoppingCartStore = createStore({
  storeName: 'ShoppingCartStore',
  handlers: {
    [ShoppingCartConstants.FETCH_SHOPPING_CART_START]      : 'fetchStart',
    [ShoppingCartConstants.FETCH_SHOPPING_CART_SUCCESS]    : 'fetchSuccess',
    [ShoppingCartConstants.FETCH_SHOPPING_CART_FAILURE]    : 'fetchFailure',
    [ShoppingCartConstants.UPDATE_SHOPPING_CART_START]     : 'updateStart',
    [ShoppingCartConstants.UPDATE_SHOPPING_CART_SUCCESS]   : 'updateSuccess',
    [ShoppingCartConstants.UPDATE_SHOPPING_CART_FAILURE]   : 'updateFailure',
    [ShoppingCartConstants.CHECKOUT_SHOPPING_CART_START]   : 'checkoutStart',
    [ShoppingCartConstants.CHECKOUT_SHOPPING_CART_SUCCESS] : 'checkoutSuccess',
    [ShoppingCartConstants.CHECKOUT_SHOPPING_CART_FAILURE] : 'checkoutFailure',
    [CustomerConstants.AUTH_CUSTOMER_SUCCESS]              : 'clearAll',
    [CustomerConstants.SIGNOUT_CUSTOMER_START]             : 'clearAll'
  },

  initialize() {
    this.shoppingCarts = new Map();
    this.errors = new Map();
    this.requestStatusByStoreId = new Map();
  },

  logError(error) {
    if(typeof Bugsnag !== 'undefined' && error) {
      Bugsnag.notifyException(error, error.name || 'Error', {metadata: error.metadata} || {});
    }
  },

  clearAll() {
    // Clear existing carts on customer change
    this.shoppingCarts = new Map();
    this.emitChange();
  },

  fetchStart(storeId) {
    // this.requestStatusByStoreId = this.requestStatusByStoreId.set(storeId, RequestStates.Loading);
    // this.emitChange();
  },

  fetchSuccess(shoppingCart) {
    let storeId = shoppingCart.store.id;
    // this.requestStatusByStoreId = this.requestStatusByStoreId.set(storeId, RequestStates.Done);
    this.shoppingCarts = this.shoppingCarts.set(storeId, shoppingCart);
    this.emitChange();
  },

  fetchFailure(data) {
    // this.requestStatusByStoreId = this.requestStatusByStoreId.set(data.storeId, RequestStates.Error);
    this.errors = this.errors.set(data.storeId, data.error);
    this.logError(data.error);
    this.emitChange();
  },

  updateStart(storeId) {
    this.requestStatusByStoreId = this.requestStatusByStoreId.set(storeId, RequestStates.Loading);
    this.emitChange();
  },

  updateSuccess(shoppingCart) {
    let storeId = shoppingCart.store.id;
    this.requestStatusByStoreId = this.requestStatusByStoreId.set(storeId, RequestStates.Done);
    this.shoppingCarts = this.shoppingCarts.set(storeId, shoppingCart);
    this.emitChange();
  },

  updateFailure(data) {
    this.requestStatusByStoreId = this.requestStatusByStoreId.set(data.storeId, RequestStates.Error);
    this.errors = this.errors.set(data.storeId, data.error);
    this.logError(data.error);
    this.emitChange();
  },

  checkoutStart(storeId) {
    this.requestStatusByStoreId = this.requestStatusByStoreId.set(storeId, RequestStates.Loading);
    this.emitChange();
  },

  checkoutSuccess(data) {
    let storeId = data.shoppingCart.store.id;
    this.requestStatusByStoreId = this.requestStatusByStoreId.set(storeId, RequestStates.Done);
    this.shoppingCarts = this.shoppingCarts.set(storeId, data.shoppingCart);
    this.emitChange();
  },

  checkoutFailure(data) {
    if(!data.error) {
      // Likely an error in CustomerActions.addPaymentMethod so just update requestStatus
      this.requestStatusByStoreId = this.requestStatusByStoreId.set(data.storeId, RequestStates.Error);
      return this.emitChange();
    }
    this.requestStatusByStoreId = this.requestStatusByStoreId.set(data.storeId, RequestStates.Error);
    this.errors = this.errors.set(data.storeId, data.error);
    this.logError(data.error);
    this.emitChange();
  },

  getShoppingCartByStoreId(storeId) {
    return this.shoppingCarts.get(storeId);
  },

  getErrorByStoreId(storeId) {
    return this.errors.get(storeId);
  },

  getRequestStatusByStoreId(storeId) {
    return this.requestStatusByStoreId.get(storeId);
  },

  dehydrate() {
    return {
      shoppingCarts: this.shoppingCarts.toJS(),
      errors: this.errors.toJS(),
      requestStatusByStoreId: this.requestStatusByStoreId.toJS()
    };
  },

  rehydrate(state) {
    this.shoppingCarts = _.reduce(state.shoppingCarts, (map, shoppingCart, id) => {
      return map.set(id, new ShoppingCart(shoppingCart));
    }, new Map());
    this.errors = fromJS(state.errors);
    this.requestStatusByStoreId = fromJS(state.requestStatusByStoreId);
  }
});

export default ShoppingCartStore;



// WEBPACK FOOTER //
// banquet/stores/ShoppingCartStore.js